<template>
    <div class="navigation-container w-clearfix">
        <a href="index.html" class="brand-logo w-nav-brand">
            <img src="images/DemandScale-Marketing-Logo.png" alt=""></a>
        <nav role="navigation" class="navigation-links w-nav-menu">
            <div data-delay="0" class="navigation-dropdown w-dropdown">
                <div class="navigation-link w-dropdown-toggle">
                    <div class="inline">{{$t('why')}}</div>
                    <div class="navigation-dropdown-icon inline w-icon-dropdown-toggle"></div>
                </div>
                <nav class="navigation-dropdown-list w-dropdown-list">
                    <div class="navigation-dropdown-header">
                        <a href="index.html#scaleup" class="navigation-dropdown-link scale w-inline-block">
                            <img src="images/Group.svg" width="35" height="35" alt="">
                            <div class="navigation-dropdown-link-content">
                                <div class="navigation-dropdown-link-title scale">{{$t('scale_up')}}</div>
                                <div class="navigation-dropdown-link-text">{{$t('over')}} {{dailyActiveUsers}} {{$t('daus')}} &amp; {{monthlyActiveUsers}} {{$t('maus')}}</div>
                            </div>
                        </a>
                        <a href="index.html#ai" class="navigation-dropdown-link scale w-inline-block">
                            <img src="images/Make.svg" width="35" height="35" alt="">
                            <div class="navigation-dropdown-link-content">
                                <div class="navigation-dropdown-link-title make">{{$t('make_every_dollar')}}</div>
                                <div class="navigation-dropdown-link-text">{{$t('maximize_your_return')}}</div>
                            </div>
                        </a>
                        <a href="index.html#fakeusers" class="navigation-dropdown-link dont w-inline-block">
                            <img src="images/Dont.svg" width="35" height="35" alt="">
                            <div class="navigation-dropdown-link-content">
                                <div class="navigation-dropdown-link-title dont">{{$t('dont_waste_money')}}</div>
                                <div class="navigation-dropdown-link-text">{{$t('our_fraud_protection')}}</div>
                            </div>
                        </a>
                        <a href="index.html#keeptabs" class="navigation-dropdown-link keep w-inline-block">
                            <img src="images/Keep.svg" width="35" height="35" alt="">
                            <div class="navigation-dropdown-link-content">
                                <div class="navigation-dropdown-link-title keep">{{$t('keep_tabs')}}</div>
                                <div class="navigation-dropdown-link-text">{{$t('no_guesswork')}}</div>
                            </div>
                        </a>
                    </div>
                </nav>
            </div>
            <a href="index.html#socialproof" class="navigation-link w-nav-link">{{$t('social_proof')}}</a>
            <a href="about.html" class="navigation-link w-nav-link">{{$t('about')}}</a>
            <a href="contact.html" class="navigation-link w-nav-link">{{$t('Contact')}}</a>
            <a href="faq.html" class="navigation-link w-nav-link">{{$t('faq')}}</a>
            <a href="login.html" class="navigation-link w-nav-link">{{$t('log_in')}}</a>
        </nav>
        <div class="menu-button w-nav-button">
            <div class="w-icon-nav-menu"></div>
        </div>
        <div class="navigation-actions">
            <div class="navigation-action"><a href="signup.html" class="ds-button button-small w-button">{{$t('get_started')}}</a></div>
        </div>
    </div>
</template>

<style>
</style>

<script>
    export default {
        data () {
            return {
                dailyActiveUsers: '74M',
                monthlyActiveUsers: '637M'
            }
        },
    }
</script>
